import { useState } from "react";
import { toast } from "sonner";
import { Plus, PencilSimple, X, FloppyDisk } from "@phosphor-icons/react";
import api, { formatApiError } from "../../lib/api";
import { inputCls, cellInputCls } from "./shared";

const blank = () => ({ name: "", contact_email: "", phone: "", address: "" });

export function Suppliers({ suppliers, onChange }) {
  const [form, setForm] = useState(blank());
  const [editing, setEditing] = useState(null);
  const set = (k, v) => setForm((f) => ({ ...f, [k]: v }));

  const create = async (e) => {
    e.preventDefault();
    try {
      await api.post("/scm/suppliers", form);
      toast.success("Supplier added");
      setForm(blank());
      onChange();
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail));
    }
  };

  const save = async () => {
    try {
      const { name, contact_email, phone, address } = editing;
      await api.patch(`/scm/suppliers/${editing.id}`, { name, contact_email, phone, address });
      toast.success("Supplier updated");
      setEditing(null);
      onChange();
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail));
    }
  };

  const setE = (k, v) => setEditing((r) => ({ ...r, [k]: v }));

  return (
    <div>
      <form onSubmit={create} className="grid grid-cols-2 md:grid-cols-[1fr_1fr_160px_1fr_auto] gap-px bg-zinc-200 border-b border-zinc-950" data-testid="supplier-form">
        <input value={form.name} onChange={(e) => set("name", e.target.value)} required placeholder="Name" data-testid="supplier-name-input" className={inputCls} />
        <input type="email" value={form.contact_email} onChange={(e) => set("contact_email", e.target.value)} required placeholder="Email" data-testid="supplier-email-input" className={inputCls} />
        <input value={form.phone} onChange={(e) => set("phone", e.target.value)} placeholder="Phone" data-testid="supplier-phone-input" className={`${inputCls} tnum`} />
        <input value={form.address} onChange={(e) => set("address", e.target.value)} placeholder="Address" data-testid="supplier-address-input" className={inputCls} />
        <button type="submit" className="bg-zinc-950 text-white text-xs font-semibold px-5 hover:bg-[#FF3E00] flex items-center justify-center gap-1" data-testid="supplier-create-btn">
          <Plus size={14} /> ADD
        </button>
      </form>
      <table className="w-full text-sm">
        <thead className="bg-zinc-50 border-b border-zinc-950">
          <tr className="text-xs tracking-wider uppercase">
            <th className="text-left px-4 py-2.5">Name</th>
            <th className="text-left px-4 py-2.5">Contact</th>
            <th className="text-left px-4 py-2.5">Phone</th>
            <th className="text-left px-4 py-2.5">Address</th>
            <th className="w-28" />
          </tr>
        </thead>
        <tbody data-testid="suppliers-tbody">
          {suppliers.map((s) => (editing?.id === s.id ? (
            <tr key={s.id} className="border-b border-zinc-100 bg-amber-50/40" data-testid="supplier-edit-row">
              <td className="px-2 py-1.5"><input value={editing.name} onChange={(e) => setE("name", e.target.value)} className={cellInputCls} data-testid="supplier-edit-name" /></td>
              <td className="px-2 py-1.5"><input type="email" value={editing.contact_email} onChange={(e) => setE("contact_email", e.target.value)} className={cellInputCls} data-testid="supplier-edit-email" /></td>
              <td className="px-2 py-1.5"><input value={editing.phone || ""} onChange={(e) => setE("phone", e.target.value)} className={`${cellInputCls} tnum`} data-testid="supplier-edit-phone" /></td>
              <td className="px-2 py-1.5"><input value={editing.address || ""} onChange={(e) => setE("address", e.target.value)} className={cellInputCls} data-testid="supplier-edit-address" /></td>
              <td className="px-2 py-1.5">
                <div className="flex items-center gap-2">
                  <button onClick={save} className="bg-zinc-950 text-white text-[10px] font-semibold px-3 py-1.5 hover:bg-[#FF3E00] flex items-center gap-1" data-testid="supplier-save-btn"><FloppyDisk size={11} /> SAVE</button>
                  <button onClick={() => setEditing(null)} className="text-[10px] font-mono text-zinc-500 hover:text-zinc-950" data-testid="supplier-cancel-edit-btn"><X size={11} /></button>
                </div>
              </td>
            </tr>
          ) : (
            <tr key={s.id} className="border-b border-zinc-100 hover:bg-zinc-50" data-testid={`supplier-row-${s.id}`}>
              <td className="px-4 py-2.5 font-medium">{s.name}</td>
              <td className="px-4 py-2.5 text-zinc-600">{s.contact_email}</td>
              <td className="px-4 py-2.5 tnum text-xs text-zinc-500">{s.phone}</td>
              <td className="px-4 py-2.5 text-zinc-500">{s.address}</td>
              <td className="px-4 py-2.5">
                <button onClick={() => setEditing({ ...s })} className="text-[10px] font-mono text-zinc-500 hover:text-zinc-950 flex items-center gap-1" data-testid={`supplier-edit-${s.id}`}><PencilSimple size={11} /> EDIT</button>
              </td>
            </tr>
          )))}
        </tbody>
      </table>
    </div>
  );
}
